document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant;
  if (!variant) return;

  function formatMoney(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-UY');
  }

  // Precio principal
  var priceEl = document.querySelector('.mg-ux-price');
  if (priceEl) priceEl.innerText = formatMoney(variant.price);

  // Precio tachado y badge de descuento
  var compareEl = document.querySelector('.mg-ux-compare');
  var discountEl = document.querySelector('.mg-ux-discount');
  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    var discountPct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
    if (compareEl) { compareEl.innerText = formatMoney(variant.compare_at_price); compareEl.style.display = ''; }
    if (discountEl) { discountEl.innerText = '-' + discountPct + '%'; discountEl.style.display = ''; }
  } else {
    if (compareEl) compareEl.style.display = 'none';
    if (discountEl) discountEl.style.display = 'none';
  }

  // Stock disponible
  var stockEl = document.querySelector('.mg-ux-live-stock .mg-ux-live-text strong');
  if (stockEl) {
    var qty = variant.inventory_quantity;
    if (qty <= 0) {
      stockEl.innerText = '0';
    } else if (qty < 10) {
      stockEl.innerText = qty;
    } else {
      stockEl.innerText = Math.floor(Math.random() * 8) + 8;
    }
  }
});
